import {useLoadDraftFromRoute} from './useLoadDraftFromRoute';
import {useParams} from 'react-router-dom';
import {useRewardsBase} from './useRewardsBase';

/**
 * Hook for View Reward flow
 * Handles view-specific logic: loads draft on mount, starts at step 4, read-only mode, no actions
 */
export const useRewardsView = () => {
  const common = useRewardsBase();
  const {id} = useParams();
  const {
    currentStep,
    formData,
    validation,
    isLoading,
    loadDraft,
    dispatch,
    ...restCommon
  } = common;

  useLoadDraftFromRoute({
    id,
    rewardId: formData?.rewardId,
    loadDraft,
    dispatch
  });

  // View mode: no navigation, no actions
  // Note: We don't return handleNext, handleDraft, handlePublish, handlePrevious
  // because ViewReward doesn't use them (showFooter=false) and they're not needed

  return {
    ...restCommon,
    currentStep,
    formData,
    validation,
    isLoading,
    disableDraft: true // Always disabled in view mode
  };
};
